export const venueServiceFeeQueryFields = `
    id
    enabled
    factor
`;
